var _ = require('underscore/underscore.js');

var template = require('./SubmissionFormInformationTv.jinja');
require('./SubmissionFormInformationTv.less');

var SubmissionFormBlock = require('./SubmissionFormBlock');

module.exports = SubmissionFormBlock.extend({

    template: template,

    events: {

    },

    initialize: function (options) {
        this.options = options || {};

        SubmissionFormBlock.prototype.initialize.call(this, options);
    },


    checkRequired: function () {
        return SubmissionFormBlock.prototype.checkRequired.call(this);
    },


    getFormData: function () {
        return {
            'title': this.$('input[name="title"]').val(),
            'setsAllNew': this.$('input[name="setsAllNew"]').is(':checked'),
            'filmedInUs': this.$('input[name="filmedInUs"]:checked').val() == '1' ? true : this.$('input[name="filmedInUs"]:checked').val() == '0' ? false : null,
            'iatseAgreement': this.$('input[name="iatseAgreement"]:checked').val() == '1' ? true : this.$('input[name="iatseAgreement"]:checked').val() == '0' ? false : null,
            'company': this.$('input[name="company"]').val(),
            'description': this.$('textarea[name="description"]').val()
        };
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/submissions/components/SubmissionForm/SubmissionFormInformationTv.js
// module id = 118
// module chunks = 0